export const getQueryParamsForCategoryModal = (item = null, page = null, searchText = '') => {
  if (!item)
    return `?f[parent_id]=null${page ? `&page=${page}` : ''}${searchText?.length ? `&s[name]=${searchText}` : ''}&level=1`;
  const parentIdParam = item?.child?.id
    ? `f[parent_id]=${item?.child?.id}&level=3`
    : `f[parent_id]=${item?.parent?.id}&level=2`;
  return `?${parentIdParam}${page ? `&page=${page}` : ''}${searchText?.length ? `&s[name]=${searchText}` : ''}`;
};

export const getChildList = (list = []) => {
  return list?.find((item) => !!item?.child?.length)?.child;
};

export const getSubChildList = (list = []) => {
  return list.flatMap((item) => item.child?.flatMap((child) => child.subChild || []) || []);
};

export const getModalValue = (value = null) => {
  if (!value) return '';
  if (!value?.child) return `${value?.parent?.name}`;
  if (!value?.subChild) return `${value?.parent?.name} - ${value?.child?.name}`;
  return `${value?.parent?.name} - ${value?.child?.name} - ${value?.subChild?.name}`;
};
